import { createStyles } from '@mantine/core';

const useStyles = createStyles((theme) => ({
  layout: {
    paddingTop: theme.other.spacing._16,
    paddingLeft: theme.other.layout.paddingLg,
    paddingRight: theme.other.layout.paddingLg,
    [theme.fn.smallerThan('lg')]: {
      paddingLeft: theme.other.layout.paddingMd,
      paddingRight: theme.other.layout.paddingMd,
    },
    [theme.fn.smallerThan('md')]: {
      paddingLeft: theme.other.layout.paddingSm,
      paddingRight: theme.other.layout.paddingSm,
    },
    maxWidth: theme.other.layout.maxWidth,
    width: '100%',
    margin: '0 auto',
  },

  promoContainer: {
    padding: `${theme.other.spacing._16}px 0 ${theme.other.spacing._24}px 0`,

    '&:empty': {
      display: 'none',
    },
  },

  lobbyWrapper: {
    position: 'relative',
    padding: `${theme.other.spacing._16}px 0`,
    flexShrink: 0,
  },
}));

export default useStyles;
